<div class="content-layout">
  <ts-page-header [displaySeparationBorder]="true">
    <span page-header-title class="font-ts-header-title text-ts-header-title">Users</span>
    <div class="flex justify-end align-center gap-2" page-header-action-buttons>
      <ts-button icon="ts_user-plus" variant="primary" class="ml-2" (click)="inviteUser()"> Invite User</ts-button>

      @if (!newPermissionFeatureEnabled) {
        <button class="add-contact ml-2" mat-flat-button [color]="'primary'" (click)="addTeam()">
          <mat-icon [svgIcon]="'add'"></mat-icon>
          Add Team
        </button>
      }
    </div>
  </ts-page-header>

  <div class="main">
    <!-- Tabs -->
    <mat-tab-group>
      <mat-tab label="Users">
        <table mat-table [dataSource]="userAssociationsDataSource" [trackBy]="trackByFn">
          <ng-container matColumnDef="id">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let userAssociation">
              {{ userAssociation.user.id }}
            </td>
          </ng-container>
          <ng-container matColumnDef="full_name">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let userAssociation">
              {{ userAssociation.user.full_name }}
            </td>
          </ng-container>
          <ng-container matColumnDef="email">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Email</th>
            <td mat-cell *matCellDef="let userAssociation">
              <ng-container *ngIf="userAssociation.user.email">
                {{ userAssociation.user.email }}
              </ng-container>
            </td>
          </ng-container>
          <ng-container matColumnDef="role">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Role</th>
            <td mat-cell *matCellDef="let userAssociation">
              <mat-form-field class="flex-auto gt-xs:pt-3" appAuthorize="SETTINGS_ACCESS">
                <mat-select
                  [(ngModel)]="userAssociation.role_id"
                  (selectionChange)="onChangeUserAtt($event, userAssociation)"
                >
                  <mat-option *ngFor="let role of userRoles" [value]="role.id">{{ role.label }}</mat-option>
                </mat-select>
              </mat-form-field>
            </td>
          </ng-container>
          <ng-container matColumnDef="primary_team_id">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Teams</th>
            <td mat-cell *matCellDef="let userAssociation">
              <mat-form-field class="flex-auto gt-xs:pt-3">
                <mat-select
                  [(ngModel)]="userAssociation.primary_team_id"
                  (selectionChange)="onChangeUserAtt($event, userAssociation, 'primary_team_id')"
                >
                  <mat-option *ngFor="let team of teams" [value]="team.id">{{ team.name }}</mat-option>
                </mat-select>
              </mat-form-field>
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let userAssociation">
              <a
                (click)="disableUser(userAssociation)"
                [matTooltip]="'Disable User'"
                *ngIf="userAssociation.user.active"
              >
                <mat-icon class="icon-size-20 mr-1" [svgIcon]="'block'"></mat-icon>
              </a>
              <a
                (click)="restoreUser(userAssociation)"
                [matTooltip]="'Restore User'"
                *ngIf="!userAssociation.user.active"
              >
                <mat-icon class="icon-size-20 mr-1" [svgIcon]="'refresh'"></mat-icon>
              </a>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="usersTableColumns"></tr>
          <tr
            class="contact-row"
            mat-row
            *matRowDef="let row; columns: usersTableColumns"
            [ngClass]="{ disabled: !row.user.active }"
          ></tr>
        </table>
      </mat-tab>

      <mat-tab label="Pending">
        <table mat-table [dataSource]="invitations$" [trackBy]="trackByFn">
          <ng-container matColumnDef="email">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Email</th>
            <td mat-cell *matCellDef="let invitation">
              {{ invitation.email }}
            </td>
          </ng-container>
          <ng-container matColumnDef="full_name">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Sender Name</th>
            <td mat-cell *matCellDef="let invitation">
              {{ invitation.sender.full_name }}
            </td>
          </ng-container>
          <ng-container matColumnDef="created_at">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Invited At</th>
            <td mat-cell *matCellDef="let invitation">
              {{ invitation.created_at | date: 'MMM dd, y' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let invitation">
              <button (click)="resendInvitation(invitation)" mat-icon-button [matTooltip]="'Resend Invite'">
                <mat-icon>refresh</mat-icon>
              </button>
              <a [href]="getEmailInvitationLink(invitation)" [matTooltip]="'Open email to send'" target="_top">
                <mat-icon class="icon-size-20 mr-1" [svgIcon]="'email'"></mat-icon>
              </a>
              <button mat-icon-button (click)="deleteInvitation(invitation)">
                <mat-icon class="icon-size-20" [svgIcon]="'delete'"></mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="invitationsTableColumns"></tr>
          <tr class="contact-row" mat-row *matRowDef="let row; columns: invitationsTableColumns"></tr>
        </table>
      </mat-tab>

      @if (newPermissionFeatureEnabled === false) {
        <mat-tab label="Teams">
          <div class="flex flex-row">
            <treo-card class="flex flex-col max-w-80 w-full mt-8 px-8 pt-6 pb-4 ml-4 mr-4" *ngFor="let team of teams">
              <div class="flex items-center justify-between">
                <div class="flex flex-col">
                  <span class="text-2xl font-semibold leading-none">{{ team.name }}</span>
                  <span class="text-sm text-secondary leading-none mt-1">&#64;{{ team.mention_name }}</span>
                </div>
                <div class="-mr-3">
                  <button mat-icon-button [matMenuTriggerFor]="listCard04Menu">
                    <mat-icon class="icon-size-20" [svgIcon]="'more_vert'"></mat-icon>
                  </button>
                  <mat-menu #listCard04Menu="matMenu">
                    <button mat-menu-item (click)="deleteTeam(team)">Delete Team</button>
                  </mat-menu>
                </div>
              </div>
              <div class="flex flex-col mt-5">
                <div class="flex" *ngFor="let ua of userAssociations">
                  <mat-checkbox
                    [color]="'primary'"
                    class="mb-2"
                    (change)="toggleUserTeam(team, ua.user, $event)"
                    [checked]="teamIncludesUser(team, ua.user)"
                  >
                    <div class="flex flex-col min-w-0">
                      <div class="leading-tight">{{ ua.user.full_name }}</div>
                    </div>
                  </mat-checkbox>
                </div>
              </div>
            </treo-card>
          </div>
        </mat-tab>
      }
    </mat-tab-group>
  </div>
</div>
